import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import api from '../../utils/api';
import { useCart } from '../../context/CartContext';
import ReactPixel from 'react-facebook-pixel';
import { track } from '../../utils/analytics';

const fmtCOP = v => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v||0);
const WHATSAPP = '573113407979';

export default function PedidoOk() {
  const { state } = useLocation();
  const { vaciar } = useCart();
  const [searchParams] = useSearchParams();
  const [verificando, setVerificando] = React.useState(false);
  const [pedidoInfo, setPedidoInfo] = React.useState(null);

  React.useEffect(() => {
    vaciar();
    const wompiTxId = searchParams.get('id');
    const wompiRef = searchParams.get('reference') || searchParams.get('ref');

    if (wompiTxId) {
      setVerificando(true);
      // Consultar la transaccion al backend para obtener referencia y total
      api.get('/wompi/transaccion/' + wompiTxId)
        .then(r => {
          const tx = r.data;
          if (tx && tx.referencia) {
            return api.post('/wompi/confirmar-pago', {
              referencia: tx.referencia,
              transaccion_id: wompiTxId,
              metodo: tx.metodo || 'CARD',
              status: 'APPROVED'
            }).then(res => {
              const p = res.data?.pedido;
              if (p) {
                setPedidoInfo({ numero: p.numero, total: p.total });
                ReactPixel.track('Purchase', { value: p.total, currency: 'COP' });
                track('purchase', { valor: p.total, meta: { numero: p.numero } });
              }
            });
          }
        })
        .catch(() => {})
        .finally(() => setVerificando(false));
    } else if (wompiRef) {
      setVerificando(true);
      api.post('/wompi/confirmar-pago', {
        referencia: wompiRef,
        metodo: searchParams.get('payment_method_type') || 'CARD',
        status: 'APPROVED'
      }).then(res => {
        const p = res.data?.pedido;
        if (p) setPedidoInfo({ numero: p.numero, total: p.total });
      }).catch(() => {}).finally(() => setVerificando(false));
    } else if (state?.total > 0) {
      ReactPixel.track('Purchase', { value: state.total, currency: 'COP' });
      track('purchase', { valor: state.total, meta: { numero: state.numero } });
    }
  }, []);

  const numero = pedidoInfo?.numero || state?.numero || '';
  const total  = pedidoInfo?.total  || state?.total  || 0;
  const metodoPago = state?.metodo_pago || 'wompi';
  const transaccionId = state?.transaccion_id || searchParams.get('id') || null;
  const esWompi = metodoPago === 'wompi' || searchParams.get('id');

  const waMsg = encodeURIComponent('Hola Wawita! Realice mi pedido ' + (numero||'') + ' por ' + fmtCOP(total) + '. Quedo alguna duda?');

  if (esWompi) return (
    <div style={{ minHeight:'100vh', background:'var(--cream)', display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
      <div style={{ maxWidth:500, width:'100%', textAlign:'center' }}>
        <div style={{ width:100, height:100, borderRadius:'50%', background:'rgba(159,190,106,0.2)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 28px', fontSize:52 }}>
          ✅
        </div>
        <h1 style={{ fontFamily:'var(--font-display)', fontSize:32, color:'var(--forest)', marginBottom:8 }}>
          Pago exitoso!
        </h1>
        <p style={{ color:'var(--ink-light)', fontSize:15, lineHeight:1.7, marginBottom:28 }}>
          Tu pago fue confirmado por Wompi. Ya estamos preparando tu pedido con amor.
        </p>
        {verificando && <p style={{ color:'var(--ink-faint)', fontSize:13, marginBottom:16 }}>Verificando pago...</p>}
        <div className="card" style={{ marginBottom:20, textAlign:'left' }}>
          <div className="card-body">
            {numero && (
              <div style={{ display:'flex', justifyContent:'space-between', marginBottom:12, paddingBottom:12, borderBottom:'1px solid rgba(28,58,30,0.08)' }}>
                <span style={{ color:'var(--ink-faint)', fontSize:13 }}>Numero de pedido</span>
                <span style={{ fontWeight:900, color:'var(--forest)', fontSize:16, fontFamily:'monospace' }}>{numero}</span>
              </div>
            )}
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:12, paddingBottom:12, borderBottom:'1px solid rgba(28,58,30,0.08)' }}>
              <span style={{ color:'var(--ink-faint)', fontSize:13 }}>Total pagado</span>
              <span style={{ fontWeight:900, fontSize:20, color:'#9FBE6A' }}>{total > 0 ? fmtCOP(total) : 'Confirmado ✓'}</span>
            </div>
            {transaccionId && (
              <div style={{ display:'flex', justifyContent:'space-between', marginBottom:12, paddingBottom:12, borderBottom:'1px solid rgba(28,58,30,0.08)' }}>
                <span style={{ color:'var(--ink-faint)', fontSize:13 }}>ID Transaccion</span>
                <span style={{ fontWeight:600, fontSize:13, fontFamily:'monospace', color:'var(--forest)' }}>{transaccionId}</span>
              </div>
            )}
            <div style={{ display:'flex', justifyContent:'space-between' }}>
              <span style={{ color:'var(--ink-faint)', fontSize:13 }}>Estado</span>
              <span className="badge badge-green" style={{ background:'rgba(159,190,106,0.2)', color:'#2c5e2e', padding:'4px 12px', borderRadius:20, fontWeight:700, fontSize:12 }}>Pago confirmado</span>
            </div>
          </div>
        </div>
        <div style={{ background:'rgba(159,190,106,0.1)', border:'2px solid rgba(159,190,106,0.3)', borderRadius:16, padding:20, marginBottom:20, textAlign:'left' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:8 }}>
            <span style={{ fontSize:24 }}>📦</span>
            <div style={{ fontWeight:800, fontSize:15, color:'var(--forest)' }}>Que sigue?</div>
          </div>
          <ol style={{ paddingLeft:20, margin:0, display:'flex', flexDirection:'column', gap:6 }}>
            <li style={{ fontSize:13, color:'var(--ink-mid)', lineHeight:1.6 }}>Recibiras un correo con la confirmacion de tu pedido</li>
            <li style={{ fontSize:13, color:'var(--ink-mid)', lineHeight:1.6 }}>Prepararemos tu pedido con mucho amor</li>
            <li style={{ fontSize:13, color:'var(--ink-mid)', lineHeight:1.6 }}>Te notificaremos cuando sea enviado con el numero de guia</li>
          </ol>
        </div>
        <a href={"https://wa.me/" + WHATSAPP + "?text=" + waMsg} target="_blank" rel="noreferrer"
          style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10, width:'100%', padding:'15px 24px', marginBottom:16, background:'#25D366', color:'#fff', borderRadius:'var(--r-lg)', fontWeight:800, fontSize:15, textDecoration:'none' }}>
          Escríbenos por WhatsApp
        </a>
        <div style={{ display:'flex', gap:12, justifyContent:'center' }}>
          <Link to="/" className="btn btn-outline">Seguir comprando</Link>
          <Link to="/mi-cuenta" className="btn btn-outline">Ver mis pedidos</Link>
        </div>
      </div>
    </div>
  );

  const NUMERO = '3113407979';
  const esNequi = metodoPago === 'nequi';
  const waMsgManual = encodeURIComponent('Hola Wawita! Acabo de realizar el pago de mi pedido ' + numero + ' por ' + fmtCOP(total) + '. Te adjunto el comprobante.');
  const pasos = esNequi ? [
    'Abre tu app Nequi',
    'Envia ' + fmtCOP(total) + ' al numero ' + NUMERO,
    'Captura el comprobante y envialo por WhatsApp al ' + NUMERO,
    'Tu pedido se confirma al verificar el pago',
  ] : [
    'Abre la app de tu banco',
    'Busca la opcion Transferir con llave Bre-B',
    'Ingresa la llave: ' + NUMERO + ' y el monto ' + fmtCOP(total),
    'Envia el comprobante por WhatsApp al ' + NUMERO,
    'Tu pedido se confirma al verificar el pago',
  ];
  const icon = esNequi ? '🟣' : '🔑';
  const titulo = esNequi ? 'Paga por Nequi' : 'Paga por Bre-B (Llave)';
  const color = esNequi ? '#7B2D8B' : '#1C3A1E';
  const bgColor = esNequi ? 'rgba(123,45,139,0.06)' : 'rgba(28,58,30,0.06)';

  return (
    <div style={{ minHeight:'100vh', background:'var(--cream)', display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
      <div style={{ maxWidth:500, width:'100%', textAlign:'center' }}>
        <div style={{ width:100, height:100, borderRadius:'50%', background:'rgba(159,190,106,0.2)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 28px', fontSize:52 }}>🌿</div>
        <h1 style={{ fontFamily:'var(--font-display)', fontSize:32, color:'var(--forest)', marginBottom:8 }}>Pedido confirmado!</h1>
        <p style={{ color:'var(--ink-light)', fontSize:15, lineHeight:1.7, marginBottom:28 }}>
          Gracias por tu compra en Wawita. Completa el pago para que empecemos a preparar tu pedido con amor.
        </p>
        <div className="card" style={{ marginBottom:20, textAlign:'left' }}>
          <div className="card-body">
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:12, paddingBottom:12, borderBottom:'1px solid rgba(28,58,30,0.08)' }}>
              <span style={{ color:'var(--ink-faint)', fontSize:13 }}>Numero de pedido</span>
              <span style={{ fontWeight:900, color:'var(--forest)', fontSize:16, fontFamily:'monospace' }}>{numero}</span>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:12, paddingBottom:12, borderBottom:'1px solid rgba(28,58,30,0.08)' }}>
              <span style={{ color:'var(--ink-faint)', fontSize:13 }}>Total a pagar</span>
              <span style={{ fontWeight:900, fontSize:20, color:'#9FBE6A' }}>{fmtCOP(total)}</span>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between' }}>
              <span style={{ color:'var(--ink-faint)', fontSize:13 }}>Estado</span>
              <span className="badge badge-yellow">Pendiente de pago</span>
            </div>
          </div>
        </div>
        <div style={{ background:bgColor, border:'2px solid ' + color + '33', borderRadius:16, padding:20, marginBottom:20, textAlign:'left' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:16 }}>
            <span style={{ fontSize:28 }}>{icon}</span>
            <div>
              <div style={{ fontWeight:800, fontSize:16, color:color }}>{titulo}</div>
              <div style={{ fontSize:12, color:'var(--ink-faint)' }}>Numero / Llave: <strong style={{ fontFamily:'monospace', fontSize:14 }}>{NUMERO}</strong></div>
            </div>
          </div>
          <ol style={{ paddingLeft:20, margin:0, display:'flex', flexDirection:'column', gap:8 }}>
            {pasos.map(function(paso, i) { return <li key={i} style={{ fontSize:13, color:'var(--ink-mid)', lineHeight:1.6 }}>{paso}</li>; })}
          </ol>
        </div>
        <a href={"https://wa.me/" + WHATSAPP + "?text=" + waMsgManual} target="_blank" rel="noreferrer"
          style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10, width:'100%', padding:'15px 24px', marginBottom:16, background:'#25D366', color:'#fff', borderRadius:'var(--r-lg)', fontWeight:800, fontSize:15, textDecoration:'none' }}>
          WhatsApp — Enviar comprobante
        </a>
        <div style={{ display:'flex', gap:12, justifyContent:'center' }}>
          <Link to="/" className="btn btn-outline">Seguir comprando</Link>
          <Link to="/mi-cuenta" className="btn btn-outline">Ver mis pedidos</Link>
        </div>
      </div>
    </div>
  );
}
